export default __webpack_public_path__ + "static/media/1_about_banner.ce0c20f8.png";